
export const getTabStyle = (isTabSelected, index, tabName) => {
    return {
        minWidth: 50,
        fontWeight: isTabSelected ? "bold" : "normal",
        background: isTabSelected ? "white" : "#117aa7",
        color: !isTabSelected ? "white" : "#117aa7"
    };
};